import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_USERS, GET_USER_PROFILE, ADD_NEW_USER, DELETE_USER, UPDATE_USER } from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getUsers,
  getUserProfile,
  getMyPermissions,
} from "../../helpers/account_helper"
import { COUNTRY } from "../../helpers/api_helper"
import { getBillingAccount, getUnitHistory } from "../../helpers/billing_helper"

// toast
import { toast } from "react-toastify";
import { logoutUser } from "store/actions";

function* fetchUsers(data) {
  try {
    const response = yield call(getUsers, data)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUserProfile({payload}) {
  try {
    const me = yield call(getUserProfile);
    // Permissions aren't in the JWT — fetched separately to gate the UI.
    let permissions = [];
    try { permissions = yield call(getMyPermissions); } catch (e) { /* non-fatal */ }

    const primaryCompany = me?.companies?.[0] || {};
    const country = primaryCompany.operatingCountries?.[0] || COUNTRY;

    // Units live in billing now; surface them via a back-compat `Client` shape.
    let account = {};
    try { account = yield call(getBillingAccount, country); } catch (e) { /* non-fatal */ }

    // Lifetime granted/consumed come from unit-history (ledger sums), not /account.
    let summary = {};
    try { summary = (yield call(getUnitHistory, country))?.summary || {}; } catch (e) { /* non-fatal */ }

    const profile = {
      ...me,
      permissions: permissions || [],
      companyId: primaryCompany.id,
      isCompanyAdmin: !!primaryCompany.isAdmin,
      country,
      // Back-compat shims for pages still reading the legacy {User, Client} shape.
      User: {
        id: me?.id,
        name: [me?.firstName, me?.lastName].filter(Boolean).join(" "),
        email: me?.email,
        phone: me?.phone,
        role_id: primaryCompany.isAdmin ? 1 : 3,
        status: me?.isActive ? "1" : "0",
        client_id: primaryCompany.id,
      },
      Client: {
        remaining_units: account?.activeUnitsAvailable ?? 0,
        total_allocated_units: summary?.lifetimeGranted ?? account?.activeUnitsTotal ?? 0,
        total_used_units: summary?.lifetimeConsumed ?? 0,
        currency: account?.currencyCode,
      },
    };
    yield put(getUserProfileSuccess(profile))
  } catch (error) {
    yield put(getUserProfileFail(error))
  }
}

// function* onUpdateUser({ payload: user }) {
//   try {
//     const response = yield call(updateUser, user)
//     yield put(updateUserSuccess(response))
//     toast.success("Contact Updated Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(updateUserFail(error))
//     toast.error("Contact Updated Failed", { autoClose: 2000 });
//   }
// }

// function* onDeleteUser({ payload: user }) {
//   try {
//     const response = yield call(deleteUser, user)
//     yield put(deleteUserSuccess(response))
//     toast.success("Contact Deleted Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(deleteUserFail(error))
//     toast.error("Contact Deleted Failed", { autoClose: 2000 });
//   }
// }

// function* onAddNewUser({ payload: user }) {

//   try {
//     const response = yield call(addNewUser, user)
//     yield put(addUserSuccess(response))
//     toast.success("Contact Added Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(addUserFail(error))
//     toast.error("Contact Added Failed", { autoClose: 2000 });
//   }
// }

function* accountSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  // yield takeEvery(ADD_NEW_USER, onAddNewUser)
  // yield takeEvery(UPDATE_USER, onUpdateUser)
  // yield takeEvery(DELETE_USER, onDeleteUser)
}

export default accountSaga;
